var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPromptRecommendedFeaturesGenerator = function SvgIconPromptRecommendedFeaturesGenerator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4B4F58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "m7.714 2.226-.62 1.848a4.72 4.72 0 0 1-3.007 3.012l-1.869.621a.314.314 0 0 0 0 .598l1.869.622a4.7 4.7 0 0 1 2.983 2.988l.62 1.872a.315.315 0 0 0 .596 0l.645-1.849a4.72 4.72 0 0 1 2.983-2.988l1.868-.62a.314.314 0 0 0 0-.599l-1.845-.645a4.7 4.7 0 0 1-3.006-3.012l-.62-1.872a.315.315 0 0 0-.597.024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4F58",
    stroke: "#4B4F58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.428 2.056-.155.463a1.18 1.18 0 0 1-.751.753l-.467.155a.078.078 0 0 0-.04.12q.015.021.04.03l.467.155a1.18 1.18 0 0 1 .746.747l.155.468a.078.078 0 0 0 .149 0l.16-.462a1.18 1.18 0 0 1 .747-.747l.466-.156a.078.078 0 0 0 .04-.12.1.1 0 0 0-.04-.03l-.46-.16a1.18 1.18 0 0 1-.752-.753l-.155-.468a.079.079 0 0 0-.15.005"
  })));
};
export default SvgIconPromptRecommendedFeaturesGenerator;